<script setup lang="ts">
import { EPackageSize, TPackageItem } from "@overlay/types/enums";
import { getIcon } from "@overlay/assets";
import { onBeforeMount, onBeforeUnmount, onMounted, ref } from "vue";
import { isNativeMobileApp } from "@/mobile/isOnIOS";
import {
  AdjustEvent,
  mobileBuyPackage,
  mobileSetUserId,
  mobileTrackAdjust,
} from "@/mobile/postMessage";
import { dispatchEvent, EnumNetworkEvents } from "@shared/Events";
import { createTransaction } from "@overlay/modules/apiAccess";
import { currentAccount } from "@shared/Global";
import { Toast } from "@engine/notifications/Toast";
import { getPackages, packages } from "@uicomps/topup/data";

defineEmits(["stepComplete", "stepLoading"]);

const isPurchaseCompleted = ref(false);
const productId = ref<EPackageSize>(EPackageSize.SMALL);

const topupPackages = ref({} as { [key in EPackageSize]?: TPackageItem });

onMounted(async () => {
  topupPackages.value = await getPackages();
});

function exposedSuccess() {
  mobileTrackAdjust(AdjustEvent.SIGN_UP_PURCHASE, {
    revenue: packages.value[productId.value].price,
    currency: "USD",
  });
  $modals.closeAllModals();
  dispatchEvent(EnumNetworkEvents.NetworkRequestUserData);
  const supportMessage = document.getElementById("support-message");

  if (supportMessage) {
    supportMessage.innerText =
      "Thank you for the support! Hit the Play button to check in to the hotel!";
    supportMessage.classList.add("active");
  }
  const elements = document.querySelectorAll("." + "topup-tile");
  elements.forEach((element) => {
    element.classList.add("hide");
  });

  const imgElement = document.createElement("img");
  imgElement.src = "/assets/overlay/icons/loot-box-1.png";
  // imgElement.classList.add("imageposition");
  imgElement.style["margin"] = "0 auto";
  imgElement.style["display"] = "block";

  const targetDiv = document.getElementById("support-message");
  if (targetDiv) {
    targetDiv.appendChild(imgElement);
  }
}

function exposedFailed() {
  Toast.error("Purchase failed");
}

onBeforeMount(() => {
  (window as any)["exposedSuccess"] = exposedSuccess;
  (window as any)["exposedFailed"] = exposedFailed;
  mobileSetUserId(currentAccount.user.id || "");
});
onBeforeUnmount(() => {
  (window as any)["exposedSuccess"] = null;
  (window as any)["exposedFailed"] = null;
});

// TODO Same function as top up modal
async function generateTransaction(packageSize: EPackageSize) {
  if (isNativeMobileApp()) {
    // TODO: set loading
    productId.value = packageSize;
    mobileBuyPackage(packageSize);
  } else {
    const transaction = await createTransaction(
      packageSize,
      currentAccount.user.id,
    );

    window.location.assign(transaction.paymentURL);
  }
}
</script>
<template>
  <iframe src="/completeregistration.html"></iframe>
  <iframe v-if="isPurchaseCompleted" src="/purchasecompleted.html"></iframe>
  <div class="font font--s normal depixel pointer" id="support-message">
    {{ $t("pages.signup.topup.support") }}
  </div>
  <div
    v-for="(bthPack, size) of topupPackages"
    :v-if="Object.values(packages).length > 0"
    :key="size"
    class="topup-tile"
    @click="generateTransaction(size)"
  >
    <div
      class="inner pos--rel flex gap--m align--center padding-h--sm border-radius--m"
      :class="{ 'padding-mobile': isNativeMobileApp() }"
      :v-if="bthPack && bthPack.image"
    >
      <img :src="getIcon(bthPack?.image)" class="chest" alt="Package size" />
      <div
        v-depixel-outlined
        class="price font--ssm color-text--yellow-300 shadow flex vertical ws-no-wrap"
      >
        {{ bthPack?.tokenAmount }} sBTH
        <img
          :src="getIcon(bthPack?.bonusImage)"
          class="bonus"
          alt="Added bonus"
        />
      </div>
      <div
        v-depixel
        class="font--s spacer-l--auto ws-no-wrap"
        :class="{ amount: isNativeMobileApp() }"
      >
        {{ isNativeMobileApp() ? bthPack?.mobilePrice : `$ ${bthPack?.price}` }}
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.ws-no-wrap {
  white-space: nowrap;
}

.amount {
  right: 3px;
  top: 30px;
  position: absolute;
  font-size: 14px;
}

.padding-mobile {
  padding: 0 !important;
}
.topup-tile {
  @include borderGradientBeforeAfter(
    #fdfdfd,
    #dedede,
    s,
    m,
    $background: linear-gradient(to bottom, #ffffff, #f2f2f2)
  );
  cursor: pointer;

  &::before {
    box-shadow: 0 0 16px 0 get-color(white-400);
  }
  img {
    width: fit-content;
    image-rendering: pixelated;
  }
  .chest {
    max-width: 64px;
  }
  .inner {
    z-index: 1;
    translate: 0 0 1px;
  }

  .price {
    -webkit-text-stroke: 1px #be6501;
  }
}

.imageposition {
  display: block !important;
  margin: 0 auto !important;
}

.active {
  color: #76da7a;
}
.hide {
  display: none;
}
</style>
